import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { useCallback, useState } from '@wordpress/element';
import { createHigherOrderComponent, __experimentalUseFocusOutside as useFocusOutside } from '@wordpress/compose';
export default createHigherOrderComponent(WrappedComponent => props => {
  const [handleFocusOutside, setHandleFocusOutside] = useState();
  const bindFocusOutsideHandler = useCallback(node => setHandleFocusOutside(() => node !== null && node !== void 0 && node.handleFocusOutside ? node.handleFocusOutside.bind(node) : undefined), []);
  return createElement("div", useFocusOutside(handleFocusOutside), createElement(WrappedComponent, _extends({
    ref: bindFocusOutsideHandler
  }, props)));
}, 'withFocusOutside');
//# sourceMappingURL=index.js.map